import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authReducer from './auth/authSlice';
import userReducer from './user/userSlice';
import creditsReducer from './credits/creditsSlice';
import integrationsReducer from './integrations/integrationsSlice';
import uiReducer from './ui/uiSlice';
import { setupInterceptors } from '@/services/api/client';
import { logout } from './auth/authSlice';
import { showInsufficientCreditsModal } from './ui/uiSlice';

// Only persist the token within the auth slice
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token'],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  user: userReducer,
  credits: creditsReducer,
  integrations: integrationsReducer,
  ui: uiReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// Wire up Axios interceptors with Redux store access
setupInterceptors(store, { logout, showInsufficientCreditsModal });
